let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("f8yPF")).then(() => parcelRequire('jg2EL'));